var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBranches = function SvgBranches(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "branches_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#branches_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#branches_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.566 5.25a4.658 4.658 0 0 1-9.316 0h9.316ZM9.434 18.75a4.658 4.658 0 0 1 4.658-4.657 4.658 4.658 0 0 1 4.66 4.657H9.433ZM5.25 9.437a4.658 4.658 0 1 1 0 9.313V9.437ZM18.75 14.562a4.658 4.658 0 0 1-4.659-4.656A4.659 4.659 0 0 1 18.75 5.25v9.312Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "branches_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "branches_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(5.25 5.25)",
    d: "M0 0h13.5v13.5H0z"
  })))));
};
export { SvgBranches as ReactComponent };